"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.installTheseDev = exports.installThese = exports.install = void 0;
var types_1 = require("./types");
var util_1 = require("./util");
var logger_1 = __importDefault(require("../../helpers/logger"));
var app_paths_1 = require("../../helpers/app-paths");
var inquirer_1 = __importDefault(require("inquirer"));
var fs_1 = require("fs");
var cross_spawn_1 = require("cross-spawn");
var log = logger_1.default('dependency:npm-packages');
function manageDependencies(managementType, dependencies) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var installedDeps, updatedDeps, npmChild, yarnChild, _i, dependencies_1, dependency, currentVersion, latestVersion, inquired, result;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    installedDeps = [];
                    updatedDeps = [];
                    npmChild = cross_spawn_1.sync('npm', ['--version']);
                    yarnChild = cross_spawn_1.sync('yarn', ['--version']);
                    if (((_a = npmChild.status) !== null && _a !== void 0 ? _a : npmChild.error) &&
                        ((_b = yarnChild.status) !== null && _b !== void 0 ? _b : yarnChild.error)) {
                        throw new Error('must have `npm` or `yarn` installed to manage dependenices');
                    }
                    if (!fs_1.existsSync(app_paths_1.resolve.app('package.json'))) return [3 /*break*/, 14];
                    _i = 0, dependencies_1 = dependencies;
                    _c.label = 1;
                case 1:
                    if (!(_i < dependencies_1.length)) return [3 /*break*/, 14];
                    dependency = dependencies_1[_i];
                    return [4 /*yield*/, util_1.getNpmPackageVersion(dependency)];
                case 2:
                    currentVersion = _c.sent();
                    if (!(currentVersion === null)) return [3 /*break*/, 7];
                    log("Installing " + dependency + "...");
                    if (!(managementType === types_1.ManagementType.Install)) return [3 /*break*/, 4];
                    return [4 /*yield*/, util_1.installNpmPackage(dependency)];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 4:
                    if (!(managementType === types_1.ManagementType.InstallDev)) return [3 /*break*/, 6];
                    return [4 /*yield*/, util_1.installNpmDevPackage(dependency)];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6:
                    installedDeps.push(dependency);
                    return [3 /*break*/, 13];
                case 7:
                    if (!(managementType === types_1.ManagementType.Update)) return [3 /*break*/, 12];
                    return [4 /*yield*/, util_1.getNpmLatestVersion(dependency)];
                case 8:
                    latestVersion = _c.sent();
                    if (!util_1.semverLt(currentVersion, latestVersion)) return [3 /*break*/, 10];
                    return [4 /*yield*/, inquirer_1.default.prompt([
                            {
                                type: 'confirm',
                                name: 'answer',
                                message: "[NPM]: \"" + dependency + "\" latest version is " + latestVersion + ". Do you want to update?",
                                default: false
                            }
                        ])
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                    ];
                case 9:
                    inquired = _c.sent();
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                    if (inquired.answer) {
                        log("Updating " + dependency + "...");
                        util_1.updateNpmPackage(dependency);
                        updatedDeps.push(dependency);
                    }
                    return [3 /*break*/, 11];
                case 10:
                    log("\"" + dependency + "\" is up to date");
                    _c.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    log("\"" + dependency + "\" is already installed");
                    _c.label = 13;
                case 13:
                    _i++;
                    return [3 /*break*/, 1];
                case 14:
                    result = new Map();
                    result.set(types_1.ManagementType.Install, installedDeps);
                    result.set(types_1.ManagementType.Update, updatedDeps);
                    return [2 /*return*/, result];
            }
        });
    });
}
var dependencies = ['tauri'];
function install() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.Install, dependencies)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.install = install;
function installThese(dependencies) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.Install, dependencies)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.installThese = installThese;
function installTheseDev(dependencies) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.InstallDev, dependencies)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.installTheseDev = installTheseDev;
function update() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.Update, dependencies)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.update = update;
